import beqautyproproduct from "../../src/Images/beqautyproproduct.png";

const NeooCardShowModal = ({ closemodal, data }) => {

    return (
        <div className='otherprofudvtmodalbackbox'>
            <div className='mdl-sub-backbox'>
                <div className='threedorttsdcoroodivflx'>
                    <div className='imnmnproduuccrtisocross' onClick={() => closemodal()} style={{ cursor: "pointer" }}>
                        <i className='fa-solid fa-xmark'></i>
                    </div>
                </div>

                <div className='produtitleimggsdescrdiv'>
                    <div className='mdl-img-container'>
                        <img src={data?.neooCardImageUrl || beqautyproproduct} alt='...' />
                    </div>
                    <div className='text-center' style={{ marginBottom: '1rem' }}>
                        <button className="btn btn-download-card" onClick={() => {
                            const link = document.createElement('a');
                            link.href = data?.neooCardImageUrl || beqautyproproduct;
                            link.download = "neoo_card.png";
                            document.body.appendChild(link);
                            link.click();
                            document.body.removeChild(link);
                        }}>
                            <i className="fa fa-download fa-border-style"></i>  Save
                        </button>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default NeooCardShowModal
